module.exports = __webpack_public_path__ + "static/media/count10Off_326.4d785519.png";